import { render, staticRenderFns } from "./tab-hint.vue?vue&type=template&id=d180f9ac&scoped=true"
import script from "./tab-hint.vue?vue&type=script&lang=js"
export * from "./tab-hint.vue?vue&type=script&lang=js"
import style0 from "./tab-hint.vue?vue&type=style&index=0&id=d180f9ac&prod&lang=sass&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d180f9ac",
  null
  
)

export default component.exports